/* eslint-disable no-console */
import {DEBUG} from 'config/app.config';

export { RbLog as default, logError }

function logFatal(msg) { if(DEBUG) console.error('FATAL: ', msg) }
function logError(msg) { if(DEBUG) console.error('Error: ', msg) }
function logWarning(msg) { if(DEBUG) console.trace('WARNING: ', msg) }
function logMessage(msg) { if(DEBUG) console.log('Info: ', msg) }

function RbLog() {}

RbLog.fatal = logFatal;
RbLog.error = logError;
RbLog.warning = logWarning;
RbLog.info = logMessage;
